<template>
    <div id="order">
        <div class="wrap">
            <form @submit="buy();$emit('closeOrder')">
            <p class="title">Оформление заказа</p>
            <input class="full" v-model="info.name" placeholder="Имя Фамилия*" required>
            <input class="half" v-model="info.email" type="e-mail" placeholder="e-mail*" required>
            <input class="half" v-model="info.phone" type="tel" placeholder="телефон*" required>
            <input class="half" v-model="info.city" placeholder="город/населённый пункт*" required>
            <input class="half" v-model="info.index" placeholder="почтовый индекс*" required>
            <textarea v-model="info.address" placeholder="адрес* (улица, номер дома, подъезд, этаж, квартира)" required></textarea>
            <!-- <div class="left">
                <p>Заказ на сумму:</p>
                <p>{{order_all.sum}} руб.</p>
            </div> -->
            <!-- <div class="right">
                <p class="right_title">Оплата:</p>
                <div class="label label_first" @click="check(true)">
                    <div class="radio">
                        <div class="point" v-if="checked"></div>
                    </div>
                    <p class="label_text">Наложенный платёж</p>
                    <p class="sub_radio_label">[Оплата наличными при получении]</p>
                </div>
                <div class="label label_first" @click="check(false)">
                    <div class="radio">
                        <div class="point" v-if="!checked"></div>
                    </div>
                    <p class="label_text">Банковская карта</p>
                </div>
            </div> -->
            <div class="but_wrap">
                <button type="submit">ПОДТВЕРДИТЬ</button>
            </div>
            </form>
        </div>
    </div>    
</template>
<script>
import host from './host.js'
export default {
    name: 'Order',
    props: ['orderList'],
    data() {
        return {
            checked: true,
            order_list: this.orderList,
            order_all: {
                sum: 0,
            },
            info: {},
            content: {},
        }
    },
    methods: {
        check(value) {
            this.checked = value
        },
        buy() {
            this.content = JSON.parse(localStorage.getItem('basket'));
            if (this.checked) {
                this.info.pay_var = 'cash'
            } else {
                this.info.pay_var = 'card'
            }
            this.info.product_ids = []
            for (let item of this.order_list) {
                this.info.product_ids.push(item.id)
                for (let elem in this.content) {
                if (this.content[elem].id === item.id) {
                    this.content.splice(elem, 1)
                    localStorage.setItem('basket', JSON.stringify(this.content));
                    this.$store.dispatch('checkBasket');
                }
            }
            }
            this.$http.post(host + 'order_buy', this.info).then(function(response) {
            }, function(error) {
            })
        }
    },
    created() {
        this.order_all.sum = 0;
        for (let item of this.order_list) {
            this.order_all.sum += item.price
        }
    },
}
</script>
<style lang="scss" scoped>
.wrap {
    width: 420px;
    height: 350px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -220px;
    margin-left: -210px;
    background-color: #292929;
    z-index: 999;
    border-radius: 15px;
    padding: 35px;
    padding-top: 32px;
    text-align: left;
}
.title {
    font-size: 14pt;
    font-family: TextProMedium;
    margin-top: 0;
}
.full {
    width: 97%;
}
.full,
.half {
    height: 25px;
    background-color: transparent;
    border: 2px solid hsla(0,0%,100%,.3);
    padding-left: 2%;
    color: #fff;
    outline: none;
}
.half {
    float: left;
    width: 45%;
    margin-top: 17px;
}
.half:nth-of-type(odd) {
    margin-left: 13px;
}
textarea {
    width: 96.2%;
    height: 55px;
    background-color: transparent;
    border: 2px solid hsla(0,0%,100%,.3);
    padding-left: 2%;
    color: #fff;
    outline: none;
    font-size: 12pt;
    font-family: TextProLight;
    padding-top: 5px;
    margin-top: 17px;
    resize: none;
}
.left {
    width: 100%;
    height: auto;
    float: left;
    text-align: left;
}
.left p {
    font-size: 12pt;
    font-family: TextProMedium;
    margin-bottom: 0;
    float: left;
    margin-right: 10px;
}
.right {
    width: 50%;
    height: 100px;
    float: left;
    text-align: left;
}
.right_title {
    font-size: 12pt;
    font-family: TextProMedium;
}
.right input {
    margin-left: 0;
    float: left;
}
.label {
    width: 100%;
    float: left;
    height: 40px;
    cursor: pointer;
}
.radio {
    width: 10px;
    height: 10px;
    float: left;
    border-radius: 50%;
    border: 1px solid #cba35d;
    background-color: transparent;
}
.point {
    width: 8px;
    height: 8px;
    margin-top: 1px;
    margin-left: 1px;
    border-radius: 50%;
    background-color: #cba35d;
}
.label_text {
    float: left;
    font-size: 12pt;
    font-family: TextProMedium;
    margin-top: 0;
    margin-left: 9px;
    margin-bottom: 0;
}
.sub_radio_label {
    font-size: 9pt;
    font-family: TextProLight;
    color: gray;
    float: left;
    margin-top: 0;
    margin-left: 20px;
}
.but_wrap {
    width: 100%;
    float: left;
    height: auto;
    text-align: center;
    margin-top: 40px;
}
button {
    background-color: #cf3835;
    font-size: 12pt;
    font-family: TextProMedium;
    outline: none;
    border: none;
    padding: 10px 23px;
    padding-top: 12px;
    cursor: pointer;
}
button:hover {
    background-color: #ce4c4c;
}
button:active {
    background-color: #cf3835;
}
@media (max-width: 1024px) {
    .wrap {
        width: auto;
        height: 100%;
        top: 0;
        left: 0;
        margin-left: 0;
        margin-top: 0;
        border-radius: 0;
        padding: 5vh;
        padding-top: 15vh;
        overflow-y: scroll;
        box-sizing: border-box;
    }
    .mobile_view {
        display: block;
    }
    .mobile_view .wrap {
        position: relative;
        top: 0;
        background-color: transparent;
        padding: 5vh 0;
        height: auto;
        overflow: visible;
    }
    .mobile_view .wrap .left {
        display: none;
    }
    .title {
        font-size: 6vw;
    }
    .full,
    .half {
        height: 6vh;
        padding: 2%;
        font-family: TextProLight;
        font-size: 4vw;
        margin-left: 0!important;
        line-height: 6vh;
    }
    .full,
    .half,textarea {
        width: 100%;
        border-width: 1px;
        box-sizing: border-box;
        -webkit-appearance: none;
        border-radius: 0;
    }
    textarea {
        height: 12vh;
    }
    button {
        width: 100%;
    }
    .close_self {
        margin-top: -15px;
        width: 30px;
        height: 30px;
        background-color: #cf3835;
        cursor: pointer;
        position: absolute;
        right: 5vh;
        transform: translateY(-50%);
        top: 15vh;
        margin-top: 5vw;
        padding: 0;
    }
    .close_self img {
        width: 10px;
        height: 10px;
        margin-left: 10px;
        margin-top: 10px;
    }
}

</style>




// WEBPACK FOOTER //
// src/components/Order.vue